import Accordion from '../common/accordion';

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll('.accordion');

	const checkHashLoad = ( block ) => {
		const hash = window.location.hash.replace('#', '');
		if( hash.length ) {
			const buttons = block.querySelectorAll(`[aria-controls='${hash}']`); // TODO: check this with nested items.
			buttons.forEach((button) => {
				button.click();
			});
		}
	}

	const setupHashClickEvents = ( block ) => {
		const panelButtons = block.querySelectorAll(`[aria-controls]`); // TODO: check this with nested items.
		panelButtons.forEach((button) => {
			const panelId = button.getAttribute('aria-controls');
			const links = document.querySelectorAll(`a[href='#${panelId}']`);
			links.forEach((link) => {
				link.addEventListener("click", function ( event ) {
					button.click();
				});
			});
		});
	}

	blocks.forEach((block) => {
		new Accordion( `#${block.id}`, {
			onCreate: function() {
				const detail = {};
				block.dispatchEvent(new CustomEvent('tribe.accordion.create', { detail } ));
				checkHashLoad(block);
				setupHashClickEvents( block );
			},
			onOpen: function( accordionElements ) {
				const detail = { 'accordionElements': accordionElements };
				block.dispatchEvent(new CustomEvent('tribe.accordion.open', { detail } ));
			},
			onClose: function( accordionElements ) {
				const detail = { 'accordionElements': accordionElements };
				block.dispatchEvent(new CustomEvent('tribe.accordion.close', { detail } ));
			},
			onToggle: function( accordionElements ) {
				const detail = { 'accordionElements': accordionElements };
				block.dispatchEvent(new CustomEvent('tribe.accordion.toggle', { detail } ));
			}
		} );
	});
});
